<template>
  <h1>About Page</h1>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>